import script from "./InvoiceProductQuotaEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceProductQuotaEditor.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceProductQuotaEditor.vue?vue&type=style&index=0&id=30c45b53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c45b53"]])

export default __exports__